import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Injectable, inject } from '@angular/core';
import { SessionExpiryDialogComponent } from './session-expiry-dialog..component';

@Injectable()
export class SessionExpiryDialogService {
  private dialog = inject(MatDialog);


  openSessionExpiryDialog(): MatDialogRef<SessionExpiryDialogComponent> {

    return this.dialog.open(SessionExpiryDialogComponent,
      {
        width: '300',
        disableClose: true,
        autoFocus: true,
        backdropClass: 'blurred-background'
      });
  }
}
